import { makeStyles } from '@material-ui/core/styles'

const useStyles = makeStyles((theme) => ({
  infoCard: ({ largeCardVariant }) => ({
    borderRadius: 8,
    display: 'flex',
    flexDirection: 'row',
    flex: '1',
    minHeight: largeCardVariant ? '373px' : '245px',
    background: theme.palette.grey[100],
    color: theme.palette.secondary.main,
    boxShadow: theme.palette.shadow.cardBoxShadow,
    overflow: 'hidden',
    [theme.breakpoints.down('sm')]: {
      flexDirection: 'column',
      maxHeight: !largeCardVariant && '350px',
      width: largeCardVariant && '50%',
    },
    [theme.breakpoints.down('xs')]: {
      flexDirection: 'column',
      maxHeight: !largeCardVariant && '350px',
      width: largeCardVariant && '90%',
    },
  }),
  img: ({ largeCardVariant }) => ({
    position: 'relative',
    minHeight: 0,
    width: '40%',
    objectFit: 'cover',
    [theme.breakpoints.down('sm')]: {
      width: '100%',
      height: largeCardVariant ? '50%' : '20%',
    },
  }),
  copyContainer: ({ largeCardVariant }) => ({
    display: 'flex',
    flexDirection: 'column',
    justifyContent: 'center',
    alignItems: 'flex-start',
    background: theme.palette.background.paper,
    padding: largeCardVariant ? `${theme.spacing(6)}px ${theme.spacing(5)}px` : `${theme.spacing(3)}px ${theme.spacing(4)}px`,
    width: largeCardVariant ? '100%' : '60%',
    [theme.breakpoints.down('sm')]: {
      width: '100%',
      height: '50%',
      padding: largeCardVariant && `${theme.spacing(3)}px ${theme.spacing(3)}px`,
    },
  }),
  copyHeading: {
    margin: 0,
    ...theme.typography.h5,
  },
  copySubheading: ({ largeCardVariant }) => ({
    margin: 0,
    marginTop: theme.spacing(1),
    ...theme.typography.body1,
    color: theme.palette.text.primary,
    [theme.breakpoints.down('sm')]: {
      lineHeight: '1.4',
      marginBottom: largeCardVariant ? theme.spacing(2) : theme.spacing(4),
    },
  }),
  a11yReader: {
    position: 'absolute',
    width: 1,
    height: 1,
    padding: 0,
    margin: -1,
    overflow: 'hidden',
    clip: 'rect(0,0,0,0)',
    border: 0,
  },
  buttonCta: {
    paddingLeft: '0',
    marginTop: theme.spacing(2),
    color: theme.palette.blue.main,
    '&>span>svg': {
      color: theme.palette.blue.main,
    },
    [theme.breakpoints.down('md')]: {
      marginTop: theme.spacing(1),
    },
  },
}))

export default useStyles
